import { render } from "./KendalaTindakLanjut.vue?vue&type=template&id=66338d52"
import script from "./KendalaTindakLanjut.vue?vue&type=script&lang=js"
export * from "./KendalaTindakLanjut.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__